// Prevent multiple script execution
if (window.collectionQuickAddLoaded) {
  // Script already loaded, exit early
} else {
  window.collectionQuickAddLoaded = true;

  // Make setupQuickAdd globally available
  window.setupQuickAdd = function () {
    document.removeEventListener("click", handleGlobalClick);

    document
      .querySelectorAll(".product-card-wrapper:not(.quick-add-initialized)")
      .forEach((wrapper, index) => {
        wrapper.classList.add("quick-add-initialized");
        let timeoutId;

        // Desktop hover behavior
        if (window.innerWidth > 990) {
          wrapper.addEventListener("mouseover", function (e) {
            const quickAdd = this.querySelector(".quick-add-container");
            if (quickAdd) {
              clearTimeout(timeoutId);
              quickAdd.classList.remove("hidden");
              quickAdd.classList.add("open");

              // Prevent the global click handler from immediately closing it
              e.stopPropagation();
            }
          });

          wrapper.addEventListener("mouseout", function (e) {
            // Only handle mouseout if we're not moving to the quick add container
            const relatedTarget = e.relatedTarget || e.toElement;
            if (
              relatedTarget &&
              (this.contains(relatedTarget) ||
                relatedTarget.closest(".quick-add-container"))
            ) {
              return;
            }

            const quickAdd = this.querySelector(".quick-add-container");
            if (quickAdd) {
              timeoutId = setTimeout(() => {
                quickAdd.classList.remove("open");
              }, 100);
              quickAdd.classList.add("hidden");
            }
          });

          // Prevent quick add container from closing when hovering over it
          const quickAddContainer = wrapper.querySelector(
            ".quick-add-container"
          );
          if (quickAddContainer) {
            quickAddContainer.addEventListener("mouseover", function (e) {
              clearTimeout(timeoutId);
              e.stopPropagation();
            });

            quickAddContainer.addEventListener("mouseout", function (e) {
              // Only handle mouseout if we're not moving to another part of the container
              const relatedTarget = e.relatedTarget || e.toElement;
              if (relatedTarget && this.contains(relatedTarget)) {
                return;
              }

              timeoutId = setTimeout(() => {
                this.classList.remove("open");
                this.classList.add("hidden");
              }, 100);
            });
          }
        }

        // Mobile behavior
        const cartIcon = wrapper.querySelector(".mobile-cart-icon");
        if (cartIcon && window.innerWidth <= 990) {
          cartIcon.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            const quickAdd = wrapper.querySelector(".quick-add-container");
            if (!quickAdd) return;

            // Close other quick add containers
            document
              .querySelectorAll(".quick-add-container.open")
              .forEach((container) => {
                if (container !== quickAdd) {
                  container.classList.remove("open");
                  container.classList.add("hidden");
                }
              });

            if (quickAdd.classList.contains("open")) {
              quickAdd.classList.remove("open");
              setTimeout(() => {
                quickAdd.classList.add("hidden");
              }, 100);
            } else {
              quickAdd.classList.remove("hidden");
              requestAnimationFrame(() => {
                quickAdd.classList.add("open");
              });
            }
          });
        }
      });

    // Add global click handler with improved targeting
    document.addEventListener("click", handleGlobalClick);

    // Initialize CartManager for new products
    if (!window.cartManager) {
      window.cartManager = new window.CartManager();
    } else {
      window.cartManager.initialize();
    }
  };

  function handleGlobalClick(e) {
    if (
      !e.target.closest(".mobile-cart-icon") &&
      !e.target.closest(".quick-add-container")
    ) {
      document
        .querySelectorAll(".quick-add-container.open")
        .forEach((container) => {
          container.classList.remove("open");
          setTimeout(() => {
            container.classList.add("hidden");
          }, 100);
        });
    }
  }

  if (!window.CartManager) {
    window.CartManager = class CartManager {
      constructor() {
        this.routes = window.routes || {};
        this.initialize();
      }

      initialize() {
        this.initializeEventListeners();
      }

      initializeEventListeners() {
        document
          .querySelectorAll(".add-to-cart-button")
          .forEach((button, index) => {
            button.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              if (button.classList.contains("unavailable")) {
                return;
              }

              if (button.dataset.clicked === "true") {
                return;
              }

              const card = button.closest(".product-card-wrapper");
              if (!card) {
                return;
              }

              this.handleAddToCart(e, button, card);
            });
          });
      }

      async handleAddToCart(event, button, card) {
        const variantId = parseInt(button.dataset.variantId);

        if (!variantId || button.dataset.clicked === "true") return;
        button.dataset.clicked = "true";

        const spinnerContainer = card.querySelector(".spinner-container");
        const spinner = card.querySelector(".loading__spinner");

        try {
          spinnerContainer?.classList.remove("hidden");
          spinner?.classList.remove("hidden");

          const cart = await this.fetchCart();
          const existingItem = cart.items.find((item) => item.id === variantId);

          if (existingItem) {
            await this.updateCartItem(
              variantId,
              existingItem.quantity + 1,
              button,
              card
            );
          } else {
            await this.addItemToCart(variantId, button, card);
          }
        } catch (error) {
          this.showErrorMessage(error.message || "Failed to update cart");
          button.dataset.clicked = "false";
          spinnerContainer?.classList.add("hidden");
          spinner?.classList.add("hidden");
        }
      }

      async fetchCart() {
        const response = await fetch("/cart.js");
        if (!response.ok) throw new Error("Failed to fetch cart");
        return response.json();
      }

      async updateCartItem(variantId, quantity, button, card) {
        try {
          const response = await fetch("/cart/update.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity,
            }),
          });

          if (!response.ok) throw new Error("Failed to update item");

          await this.updateCartCount();
          await this.updateCartDrawer();
          button.dataset.clicked = "false";
          this.hideSpinner(card);

          return response.json();
        } catch (error) {
          console.error("Update Error:", error);
          throw new Error("Failed to update cart item");
        }
      }

      async addItemToCart(variantId, button, card) {
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              quantity: 1,
              id: variantId,
            }),
          });

          if (!response.ok) throw new Error("Failed to add item");

          const quickAddContainer = card.querySelector(".quick-add-container");
          if (quickAddContainer) {
            quickAddContainer.classList.add("quick-add-container-hold");
            setTimeout(() => {
              quickAddContainer.classList.remove("quick-add-container-hold");
            }, 4000);
          }

          await this.updateCartCount();
          await this.updateCartDrawer();
          button.dataset.clicked = "false";
          this.hideSpinner(card);

          return response.json();
        } catch (error) {
          throw new Error("Failed to add item to cart");
        }
      }

      hideSpinner(card) {
        const spinner = card.querySelector(".loading__spinner");
        const spinnerContainer = card.querySelector(".spinner-container");
        const addedToCartMessage = spinnerContainer?.querySelector(".hidden");

        if (spinner) spinner.classList.add("hidden");

        if (addedToCartMessage) {
          addedToCartMessage.classList.remove("hidden");
          setTimeout(() => {
            addedToCartMessage.classList.add("hidden");
            spinnerContainer?.classList.add("hidden");
          }, 4000);
        } else {
          spinnerContainer?.classList.add("hidden");
        }
      }

      async updateCartDrawer() {
        try {
          await new Promise((resolve) => setTimeout(resolve, 500));

          const response = await fetch(
            `${this.routes.cart_url}?section_id=cart-drawer`
          );
          if (!response.ok) throw new Error("Failed to fetch cart drawer");

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          const cartDrawer = document.getElementById("CartDrawer");
          const drawerInner = cartDrawer?.querySelector(".drawer__inner");
          const newDrawerInner = doc.querySelector(".drawer__inner");

          if (drawerInner && newDrawerInner) {
            drawerInner.innerHTML = newDrawerInner.innerHTML;
            document.querySelectorAll(".drawer").forEach((drawer) => {
              drawer.classList.remove("is-empty");
            });

            cartDrawer.classList.remove("is-empty");
            cartDrawer.classList.add("animate", "active");
            
            if (typeof window.fetchAndUpdateRelatedProducts === 'function') {
              console.log('Quick-add: Triggering upsell update');
              window.fetchAndUpdateRelatedProducts();
            }
          }
        } catch (error) {
          console.error("Error updating cart drawer:", error);
        }
      }

      async updateCartCount() {
        try {
          const cart = await this.fetchCart();
          const itemCount = cart.item_count;

          const cartIconBubble = document.getElementById("cart-icon-bubble");
          let cartCountBubble =
            cartIconBubble?.querySelector(".cart-count-bubble");

          if (!cartCountBubble) {
            cartCountBubble = document.createElement("div");
            cartCountBubble.className = "cart-count-bubble";
            cartCountBubble.innerHTML = `
            <span aria-hidden="true">${itemCount}</span>
            <span class="visually-hidden">${itemCount} items</span>
          `;
            cartIconBubble?.appendChild(cartCountBubble);
          } else {
            const ariaHidden = cartCountBubble.querySelector(
              '[aria-hidden="true"]'
            );
            const visuallyHidden =
              cartCountBubble.querySelector(".visually-hidden");

            if (ariaHidden) ariaHidden.textContent = itemCount;
            if (visuallyHidden)
              visuallyHidden.textContent = `${itemCount} items`;
          }

          setTimeout(() => {
            const visually = document.querySelector(
              ".cart-count-bubble .visually-hidden"
            );
            visually?.click();
          }, 1000);
        } catch (error) {
          console.error("Error updating cart count:", error);
        }
      }

      showErrorMessage(message) {
        alert(message);
      }
    };
  }

  // Initialize on page load
  document.addEventListener("DOMContentLoaded", () => {
    setupQuickAdd();
    if (!window.cartManager) {
      window.cartManager = new window.CartManager();
    }
  });

  // Initialize after load more
  document.addEventListener("products:added", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  // Initialize after collection updates
  document.addEventListener("collection:updated", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  // Initialize after cart updates
  document.addEventListener("cart:add", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  document.addEventListener("cart:update", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  document.addEventListener("cart:refresh", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  // Initialize after section updates
  document.addEventListener("shopify:section:load", () => {
    setupQuickAdd();
    if (window.cartManager) {
      window.cartManager.initialize();
    }
  });

  // Create a mutation observer to watch for new products
  const quickAddObserver = new MutationObserver((mutations) => {
    let shouldReinitialize = false;

    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (
            node.classList &&
            (node.classList.contains("product-card-wrapper") ||
              node.querySelector(".product-card-wrapper"))
          ) {
            shouldReinitialize = true;
          }
        });
      }
    });

    if (shouldReinitialize) {
      setupQuickAdd();
      if (window.cartManager) {
        window.cartManager.initialize();
      }
    }
  });

  // Start observing the product grid
  document.addEventListener("DOMContentLoaded", () => {
    const productGrid = document.getElementById("product-grid");
    if (productGrid) {
      quickAddObserver.observe(productGrid, {
        childList: true,
        subtree: true,
      });
    }
  });
} // End of else block for script loading guard
